import "../asset_library.js";

window.ThumbnailEditor = window.ThumbnailEditor || {}; // VITE_MIGRATION: ensure namespace exists before submodule assignment
ThumbnailEditor.Library = class Library {
  constructor(options) {
    this.render = this.render.bind(this);
    this.renderResults = this.renderResults.bind(this);
    this._handleQueryChanged = this._handleQueryChanged.bind(this);
    this._handleAssetSelected = this._handleAssetSelected.bind(this);
    this._getQuery = this._getQuery.bind(this);
    this._setQuery = this._setQuery.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    if (options == null) {
      options = {};
    }
    this.options = options;
    this.el = jQuery('<div class="thumbnail-editor-library">');
    this.results = jQuery('<div class="thumbnail-editor-library-results">');
    this.queryInput = jQuery(
      '<input type="text" class="thumbnail-editor-library-query-input" placeholder="Search asset library">',
    );
    this.pageType = this.options.pageType || "Image";
    this.endpoint = this.options.libraryEndpoint || "/admin/assets.json?api=asset_library";

    this.library = new Sparkle.AssetLibrary(this.endpoint, {
      debounce: 300,
      blankQueries: true,
      params: {
        page_type: this.pageType,
        limit: 40,
        archived: false,
        wildcard: true,
        detect_face: this.options.detectFace,
      },
    });

    // BEHAVIOUR

    this.queryInput.on("input", this._handleQueryChanged);
    this.queryInput.on("focus", this.renderResults);
    jQuery(this.library).on("select", this._handleAssetSelected);
    jQuery(this.library).on("update", this.renderResults);
  }

  render() {
    this.el.append(this.queryInput, this.renderResults());

    return this;
  }

  renderResults() {
    this.results.append(this.library.render().el);

    if (this.library.results) {
      this.results.show();
    } else {
      this.results.hide();
    }

    return this.results;
  }

  // EVENT HANDLERS

  _handleQueryChanged() {
    return this.library.query(this._getQuery());
  }

  _handleAssetSelected(event, ...payload) {
    this._setQuery("");
    return this._triggerEvent("choose", ...Array.from(payload));
  }

  // HELPER FUNCTIONS

  _getQuery() {
    return jQuery.trim(this.queryInput.val());
  }

  _setQuery(query) {
    return this.queryInput.val(query).triggerHandler("input");
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};
